import LabelArtistName from './labelartistname'

export default LabelArtistName
